import { Field, Text } from "@sitecore-jss/sitecore-jss-react";
import React from "react";

import { ModelState } from "../../../interfaces/modelState";
import { Card } from "../../card/Card";
import { Fieldset } from "../../fieldset/Fieldset";
import NumberInput from "../../InputFields/NumberInput";
import resetMaxValueByOffset from "../../InputFields/sanitizer/resetMaxValueByOffset";
import thousandsFormat from "../../InputFields/sanitizer/thousandsFormat";
import SliderInput from "../../InputFields/SliderInput";
import { BR301, BR302, V5 } from "../../InputFields/validator/validators";

interface Props {
  fields: Record<string, Field<string>>;
  modelState: ModelState | null;
  setModelState: (modelState: ModelState) => void;
  disabled: boolean;
  insuredAmount?: number;
  validationPropertyName: string;
  index: number;
  onUpdateCoverageInsuredAmount: (index: number, insuredAmount: number | undefined, hasInsuredAmount: boolean) => void;
  onUpdateCoverageHasInsuredAmount: (index: number) => void;
}

export const InsuredAmount = ({
  disabled,
  fields,
  insuredAmount,
  validationPropertyName,
  modelState,
  onUpdateCoverageInsuredAmount,
  onUpdateCoverageHasInsuredAmount,
  setModelState,
  index,
}: Props) => {
  const minInsuredAmount = 10000;
  const maxInsuredAmount = 999999;
  const stepValue = 10000;

  const resetModelStateUpdateInsuredAmount = (amount: number) => {
    if (modelState) {
      delete modelState[`${validationPropertyName}.InsuredAmount`];
    }
    setModelState({ ...modelState });
    onUpdateCoverageInsuredAmount(index, amount, false);
  };

  const handleNumberInputUpdate = (amount?: number) => {
    onUpdateCoverageInsuredAmount(index, amount, true);
  };

  const handleUpdateCoverageHasInsuredAmount = () => {
    onUpdateCoverageHasInsuredAmount(index);
  };

  const id = `coverage-${index}-insured-amount`;
  const titleId = `${id}-title`;

  return (
    <Fieldset aria-labelledby={titleId} disabled={disabled}>
      <Card>
        <h2 id={titleId}>
          <Text field={fields.InsuredAmountTitle} />
        </h2>
        <NumberInput
          required
          fieldData={fields}
          name="InsuredAmount"
          id={`insured_amount_${index}`}
          fieldName="InsuredAmount"
          sanitize={thousandsFormat}
          inputValue={insuredAmount}
          setModelState={setModelState}
          validators={[V5, BR301(maxInsuredAmount), BR302(minInsuredAmount)]}
          modelState={modelState}
          propertyName={`${validationPropertyName}.InsuredAmount`}
          onChange={handleNumberInputUpdate}
        />
        <SliderInput
          fieldData={fields}
          name="InsuredAmountSlider"
          id={`insured_amount_slider_${index}`}
          fieldName="InsuredAmountSlider"
          inputValue={insuredAmount}
          min={minInsuredAmount}
          max={maxInsuredAmount + 1}
          step={stepValue}
          sanitize={resetMaxValueByOffset(maxInsuredAmount + 1, 1)}
          defaultInputValue={minInsuredAmount}
          onChange={resetModelStateUpdateInsuredAmount}
          onChangeCommitted={handleUpdateCoverageHasInsuredAmount}
        />
      </Card>
    </Fieldset>
  );
};
